import nodeService from "@/services/nodejs"

/**
 * Reseta senha do usuário {{ forgotPasswordUser }}
 * @param {*} state 
 * @param {*} forgotPasswordUser 
 */
async function forgotPassword(state, forgotPasswordUser) {
    state.commit('RESET_FORGOT_PASSWORD_MESSAGE')
    state.commit('RESET_FORGOT_PASSWORD_ERROR')

    await nodeService.forgotPassword(forgotPasswordUser)
        .then(response => {
            state.commit('SET_FORGOT_PASSWORD_MESSAGE', response.data.message)
        })
        .catch(error => {
            state.commit('SET_FORGOT_PASSWORD_ERROR', error.data.message)
        })
}

async function resetPassword(state, form) {
    state.commit('RESET_RESET_PASSWORD_MESSAGE')
    state.commit('RESET_RESET_PASSWORD_ERROR')

    await nodeService.resetPassword(form)
        .then(response => {
            state.commit('SET_RESET_PASSWORD_MESSAGE', response.data.message)
        })
        .catch(error => {
            state.commit('SET_RESET_PASSWORD_ERROR', error.data.message)
        })
}

export default {
    forgotPassword,
    resetPassword,
}